// Coffee provisions a workspace against a company domain, so signing up with a free
// email provider (gmail, icloud, proton, disposable mail…) is refused by the backend
// signup gate in coffee/src/python/crm/server/auth.py.
//
// The refusal arrives as HTTP 403 with this code — deliberately not 401, which the
// Apollo error link treats as a stale token and retries after a refresh. A blocked
// signup is permanent, so it gets its own branch that routes to the explainer screen
// instead of looping.

import type { ServerError } from '@apollo/client';

export const FREE_EMAIL_SIGNUP_BLOCKED_CODE = 'free_email_signup_blocked';
export const WORK_EMAIL_REQUIRED_PATH = '/work-email-required';

interface FreeEmailBlockBody {
  code?: unknown;
  email?: unknown;
}

/**
 * The blocked address if `networkError` is the free-email refusal, else null.
 * The email falls back to '' when the body omits it — the screen renders without it.
 */
export function getFreeEmailSignupBlock(
  networkError: unknown
): { email: string } | null {
  const serverError = networkError as ServerError | null | undefined;
  if (!serverError || serverError.statusCode !== 403) return null;

  const body = serverError.result as FreeEmailBlockBody | undefined;
  if (!body || body.code !== FREE_EMAIL_SIGNUP_BLOCKED_CODE) return null;

  return { email: typeof body.email === 'string' ? body.email : '' };
}

/** Path of the "work email required" screen, carrying the attempted address. */
export function workEmailRequiredPath(email: string): string {
  return email
    ? `${WORK_EMAIL_REQUIRED_PATH}?email=${encodeURIComponent(email)}`
    : WORK_EMAIL_REQUIRED_PATH;
}
